import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from '../logger.service';

import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { CustomHttpRespone } from '../../models/customhttpresponse/custom-http-response';
import { AuthGaurdService } from '../auth-gaurd.service';
import { UpdateCommissionsUiModel } from 'src/app/models/commissionsummary/update-commissions-ui.model';

@Injectable({
  providedIn: 'root'
})
export class UpdateCommissionsUiService {

  private host = environment.apiUrl + "reviewcommissions/updatecommissionsui";
  public loggedinUser: string = '';
  public networkId: string = '';
  public email: string = '';
  public employeeId: string = '';
  public created_by: string = '';

  mySalesChannelSet = new Set<string>();

  private userRoles$?: Observable<UpdateCommissionsUiModel[]>;
  private adminConfig$?: Observable<UpdateCommissionsUiModel[]>;
  private kpis$?: Observable<UpdateCommissionsUiModel[]>;
  private comPlans$?: Observable<UpdateCommissionsUiModel[]>;
  private dropDowns$?: Observable<UpdateCommissionsUiModel[]>;
  private reportTypes$?: Observable<UpdateCommissionsUiModel[]>;

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {

  }

  public insertNavigation(payload: Pick<
    UpdateCommissionsUiModel,
    'saleschannel' | 'commplanid' | 'kpiid' | 'kpitype' | 'feedtype' | 'pagenavigation' | 'created_by' | 'created_dt'
  >): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/insertnavigation`, payload);
  }

  public getConfigTransList(id: number): Observable<UpdateCommissionsUiModel[]> {
    return this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getconfigtransList/` + id);
  }

  public getNavigationsList(): Observable<UpdateCommissionsUiModel[]> {
    return this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getconfigtransList/0`);
  }

  public deleteNavigation(id: number, userName: string): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(
      `${this.host}/deletenavigation/${id}/${encodeURIComponent(userName)}`,
      {}
    );
  }

  public onClone(id: number, userName: string): Observable<UpdateCommissionsUiModel> {
    return this.http.post<UpdateCommissionsUiModel>(`${this.host}/onclone/${id}/${encodeURIComponent(userName)}`, {});
  }

  public updateHeaders(headersEditModels: UpdateCommissionsUiModel[]): Observable<UpdateCommissionsUiModel[]> {
    return this.http.post<UpdateCommissionsUiModel[]>(`${this.host}/updateheaders`, headersEditModels);
  }

  public updateButtons(buttonsEditModels: UpdateCommissionsUiModel[]): Observable<UpdateCommissionsUiModel[]> {
    return this.http.post<UpdateCommissionsUiModel[]>(`${this.host}/updatebuttons`, buttonsEditModels);
  }

  public fetchHeaders(id: number, sc: string, commplanid: number): Observable<UpdateCommissionsUiModel[]> {
    return this.http.get<UpdateCommissionsUiModel[]>(
      `${this.host}/getheaders/${id}/${encodeURIComponent(sc)}/${commplanid}`
    );
  }

  public fetchHeaderSets(id: number): Observable<UpdateCommissionsUiModel[]> {
    return this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getheadersets/` + id);
  }

  public fetchButtons(id: number): Observable<UpdateCommissionsUiModel[]> {
    return this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getbuttons/` + id);
  }

  public insertConfig(updateCommissionsUiModel: UpdateCommissionsUiModel): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/insertconfig`, updateCommissionsUiModel);
  }

  public updateConfig(updateCommissionsUiEditModel: UpdateCommissionsUiModel): Observable<CustomHttpRespone> {
    return this.http.put<CustomHttpRespone>(`${this.host}/updateconfig`, updateCommissionsUiEditModel);
  }

  public getUserRoles(): Observable<UpdateCommissionsUiModel[]> {
    if (!this.userRoles$) {
      this.userRoles$ = this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getuserroles`).pipe(shareReplay(1));
    }
    return this.userRoles$;
  }

  public getAdminConfigData(): Observable<UpdateCommissionsUiModel[]> {
    if (!this.adminConfig$) {
      this.adminConfig$ = this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getfeedtypes`).pipe(shareReplay(1));
    }
    return this.adminConfig$;
  }

  public getKpis(): Observable<UpdateCommissionsUiModel[]> {
    if (!this.kpis$) {
      this.kpis$ = this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getkpis`).pipe(shareReplay(1));
    }
    return this.kpis$;
  }

  public getComPlans(): Observable<UpdateCommissionsUiModel[]> {
    if (!this.comPlans$) {
      this.comPlans$ = this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getcomplans`).pipe(shareReplay(1));
    }
    return this.comPlans$;
  }

  public getDropDownsData(): Observable<UpdateCommissionsUiModel[]> {
    if (!this.dropDowns$) {
      this.dropDowns$ = this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getcommsumdropdowns`).pipe(shareReplay(1));
    }
    return this.dropDowns$;
  }

  public getReportTypes(): Observable<UpdateCommissionsUiModel[]> {
    if (!this.reportTypes$) {
      this.reportTypes$ = this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getreporttypes`).pipe(shareReplay(1));
    }
    return this.reportTypes$;
  }

  /** Backend ignores path params; returns all active configs. */
  public getConfigList(): Observable<UpdateCommissionsUiModel[]> {
    return this.http.get<UpdateCommissionsUiModel[]>(`${this.host}/getconfiglist/a/0`);
  }

}
